import type { FC, ReactNode } from 'react'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { siteConfig } from '@/constants/site'

const TITLE = 'Careers at Native | Open Roles at a Web and Product Agency'
const DESCRIPTION = 'Open roles at Native, a web and product agency. We hire the best people for what our clients need, wherever they live.'

const Careers: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title={TITLE}
                description={DESCRIPTION}
                path='/careers'
                jsonLd={[
                    {
                        '@type': 'CollectionPage',
                        '@id': `${siteConfig.url}/careers#webpage`,
                        url: `${siteConfig.url}/careers`,
                        name: TITLE,
                        description: DESCRIPTION,
                        isPartOf: { '@id': `${siteConfig.url}/#website` },
                        primaryImageOfPage: { '@type': 'ImageObject', url: siteConfig.ogImage, width: 1200, height: 630 },
                        breadcrumb: { '@id': `${siteConfig.url}/careers#breadcrumb` },
                        inLanguage: 'en'
                    },
                    {
                        '@type': 'BreadcrumbList',
                        '@id': `${siteConfig.url}/careers#breadcrumb`,
                        itemListElement: [
                            { '@type': 'ListItem', position: 1, name: 'Home', item: `${siteConfig.url}/` },
                            { '@type': 'ListItem', position: 2, name: 'Careers', item: `${siteConfig.url}/careers` }
                        ]
                    }
                ]}
            />

            <header className='job-head' data-ground='light'>
                <div className='job-rail' aria-hidden='true' />
                <div className='job-head-inner'>
                    <p className='job-crumbs'>
                        <img className='job-crumbs-icon' src='/images/ui/eyebrow-triangle.svg' alt='' width={5} height={10} />
                        <a className='job-crumb-link' href='/'>Native</a>
                        <span className='job-crumb-sep'>//</span>
                        <span className='job-crumb-current'>Careers</span>
                    </p>
                    <h1 className='job-title'>Careers</h1>
                    <p className='job-intro'>
                        We hire the best people for what our clients need, wherever they live. These are the roles
                        open right now.
                    </p>
                </div>
            </header>

            <section className='job-body' data-ground='light' aria-labelledby='roles-title'>
                <div className='job-rail' aria-hidden='true' />
                <div className='job-inner'>
                    <h2 className='roles-title' id='roles-title'>Open roles</h2>
                    <ul className='roles-list'>
                        <li className='roles-item'>
                            <a className='roles-link' href='/careers/design-engineer'>
                                <span className='roles-name'>Design Engineer</span>
                                <span className='roles-meta'>Full-time · Remote · Some overlap with US hours</span>
                                <span className='roles-view'>View role &rarr;</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </section>
        </Layout>
    )
}

export default Careers
